// Identical in both arms of quiz-pv-test (#51): re-exported so there is one implementation.
export { default } from "@/components/results/steps/ResultsMealSelection";
